export const SET_LIMIT = 'AUTOMATIC_WITHDRAW_LIMIT:SET_LIMIT';
export const SET_LIMITS = 'AUTOMATIC_WITHDRAW_LIMIT:SET_LIMITS';
export const SET_CONFIG = 'AUTOMATIC_WITHDRAW_LIMIT:SET_CONFIG';
export const TOGGLE_LOADING = 'AUTOMATIC_WITHDRAW_LIMIT:TOGGLE_LOADING';

export const setLimits = (limits) => ({
    type: SET_LIMITS,
    payload: limits
});

export const setConfig = (config) => ({
    type: SET_CONFIG,
    payload: config
});

export const toggleLoading = (isLoading) => ({
    type: TOGGLE_LOADING,
    payload: isLoading
});

export const setLimit = ({ name, value }) => ({
    type: SET_LIMIT,
    payload: { name, value }
});
